var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Section",
    [
      _c("SectionHeader", {
        attrs: { title: _vm.$t("apps.billing.message.usagedetails") }
      }),
      _vm._v(" "),
      _c(
        "FormRow",
        [
          _vm.filterUsageOptions.length > 1
            ? _c("Col", { attrs: { className: "col-lg-3 mt-2" } }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tabSelected,
                        expression: "tabSelected"
                      }
                    ],
                    staticClass: "form-control custom-select",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.tabSelected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.filterUsageOptions, function(item, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: item.value } },
                      [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "Col",
                { attrs: { className: "col-lg-12" } },
                [_c("BaseLoading")],
                1
              )
            : [
                _c("Col", { attrs: { className: "col-lg-12" } }, [
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("apps.billing.message.datetimeperiod", {
                            start: _vm.getDateTimeUTC(_vm.dateStart),
                            end: _vm.getDateTimeUTC(_vm.dateEnd)
                          })
                        ) +
                        "\n      "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "Col",
                  { attrs: { className: "col-lg-12" } },
                  [
                    _vm.selected.branches
                      ? _c("BaseTableUsegeBranch", {
                          attrs: { items: _vm.branches }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.warehouses
                      ? _c("BaseTableUsegeWarehouse", {
                          attrs: { items: _vm.warehouses }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.users
                      ? _c("BaseTableUsegeUser", {
                          attrs: { items: _vm.users }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.records
                      ? _c("BaseTableUsegeApp", {
                          attrs: { items: _vm.records }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.files
                      ? _c("BaseTableUsegeFile", {
                          attrs: { items: _vm.files }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.lineMessages
                      ? _c("BaseTableUsegeMessageLine", {
                          attrs: { items: _vm.lineMessages }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.emails
                      ? _c("BaseTableUsegeEmail", {
                          attrs: { items: _vm.emails }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.qrcodes
                      ? _c("BaseTableUsegeQRCode", {
                          attrs: { items: _vm.qrcodes }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.HAS_FEE_APP_MODULES, function(app, index) {
                      return [
                        _vm.selected[
                          "APPID" + app.app_id + "_MODULEID" + app.module_id
                        ]
                          ? _c("BaseTableUsegeAppModule", {
                              key: index,
                              attrs: {
                                items:
                                  _vm.apps[
                                    "APPID" +
                                      app.app_id +
                                      "_MODULEID" +
                                      app.module_id
                                  ]
                              }
                            })
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4232382", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4232382","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/BillingInvoiceUsage.vue
// module id = null
// module chunks = 